import {useMemo, useState} from "react";
import {AgGridReact} from "ag-grid-react";
import AgGridUtils from "../../../../../../utils/aggrid-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";
import PrintableTableAgGrid from "../../../../../../components/printable-table/printable-table-ag-grid.jsx";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";

export default function AgentTrainings({ data }) {
    const trainings = data?.trainings ?? {};
    const [gridApi, setGridApi] = useState(null);

    const columnDefs = useMemo(() => ([
        { headerName: "Nome do curso", field: "courseName", flex: 1},
        { headerName: "Duração", field: "workload", flex: 0.5 },
        { headerName: "Data de início", field: "startDate", flex: 1, valueFormatter: ({value}) => ReportUtils.formatDateOnly(value) },
        { headerName: "Data de conclusão", field: "dateConclusion", flex: 1, valueFormatter: ({value}) => ReportUtils.formatDateOnly(value) },
        { headerName: "Emissão do certificado", field: "dateExpedition", flex: 1, valueFormatter: ({value}) => ReportUtils.formatDateOnly(value) },
        { headerName: "Data de validade", field: "dateExpiration", sort: "desc", flex: 1, valueFormatter: ({value}) => ReportUtils.formatDateOnly(value) },
    ]), [trainings])

    return (
        <div className="space-y-4">
            <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! mb-2 text-center text-lg! text-[#4f4f4f]">
                Formação e aperfeiçoamento
            </h2>

            <div className="w-full print:hidden mb-6">
                <AgGridReact
                    rowData={trainings ?? {}}
                    columnDefs={columnDefs}
                    defaultColDef={{ resizable: false }}
                    animateRows={false}
                    suppressCellFocus={true}
                    gridOptions={{ localeText: AgGridUtils.localization() }}
                    theme={aggridUtils.generalTheme()}
                    onGridReady={(params) => setGridApi(params.api)}
                    domLayout="autoHeight"
                />
            </div>

            <div className="hidden print:block rounded-[8px] overflow-hidden border border-[#e0e1e3] mb-6">
                <PrintableTableAgGrid
                    formatters={{
                        startDate: (row) => ReportUtils.formatDateOnly(row.startDate),
                        dateConclusion: (row) => ReportUtils.formatDateOnly(row.dateConclusion),
                        dateExpedition: (row) => ReportUtils.formatDateOnly(row.dateExpedition),
                        dateExpiration: (row) => ReportUtils.formatDateOnly(row.dateExpiration)
                    }}
                    gridApi={gridApi}
                    className="border-0! w-full -my-px"
                    thClassName="first:!border-l-0 last:!border-r-0 text-[#676a6c]"
                    tdClassName="first:!border-l-0 last:!border-r-0"
                />
            </div>
        </div>
    )
}